import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ChicagoIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7.75871 4.33324L7.19029 8.06646L9.63599 6.20431L7.75871 4.33324Z",
                fill: "#4ECCC6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.7623 13.4886L10 11.1373L7.23772 13.4886H12.7623Z",
                fill: "#4ECCC6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.13646 8.66419L6.51609 13.3303L9.60512 10.7657L7.13646 8.66419Z",
                fill: "#4ECCC6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.09449 19.1H13.9055L10 16.4679L6.09449 19.1Z",
                fill: "#4ECCC6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.51609 13.6554L6 18.5505L9.54489 16.1614L6.51609 13.6554Z",
                fill: "#4ECCC6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.3998 8.4584L10 6.56695L7.60023 8.4584H12.3998Z",
                fill: "#4ECCC6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.0241 3.82447H7.97591L10 5.84167L12.0241 3.82447Z",
                fill: "#4ECCC6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.3998 8.44947H7.60023L10 10.4295L12.3998 8.44947Z",
                fill: "#4ECCC6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.7879 8.06646L12.2413 4.33324L10.364 6.20431L12.7879 8.06646Z",
                fill: "#4ECCC6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.7623 13.48H7.23772L10 15.7133L12.7623 13.48Z",
                fill: "#4ECCC6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.4835 13.3303L12.8632 8.66419L10.3945 10.7657L13.4835 13.3303Z",
                fill: "#4ECCC6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14 18.5505L13.4835 13.6554L10.4551 16.1614L14 18.5505Z",
                fill: "#4ECCC6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.01223 1.5C8.87709 1.5 8.76755 1.60397 8.76755 1.73223V3.82447H9.25692V1.73223C9.25692 1.60397 9.14737 1.5 9.01223 1.5Z",
                fill: "#4ECCC6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10.9878 1.5C10.8526 1.5 10.7431 1.60397 10.7431 1.73223V3.82447H11.2324V1.73223C11.2324 1.60397 11.1229 1.5 10.9878 1.5Z",
                fill: "#4ECCC6"
            })
        ]
    });
